import {callURL} from './call';
import messageShow from "./messageShow";
import {UPDATE_DATA} from "../types";
import {signerURL} from "../url";
import logout from "./logout";

const getWorkflowFilesInformation= (formValues) => async (dispatch) =>
{
    let skip=formValues.skip;
    const limit=formValues.limit;
    if(skip && limit)
        formValues.skip = (skip - 1) * limit;
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            const filesInfo=result[1].filesInfo;
            if(filesInfo)
                dispatch({type:UPDATE_DATA,payload:{workflowList:filesInfo}});
        }
        else
        {
            if(result && result[1] && result[1].code===440)
                dispatch(logout());
            else
                dispatch(messageShow({message: result[1].detail, type: 'error'}));
        }

    }
    dispatch(callURL(signerURL,"rest/UserService/getWorkflowFilesInformation",formValues,onResult));
};
export default getWorkflowFilesInformation;